import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '@env/environment';
import { User } from '@app/shared/models/user.model';
import * as jwt_decode from 'jwt-decode';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private apiUrl = `${environment.apiHost}/api/user`;

    constructor(private http: HttpClient) {
        
    }

    getUser(idToken: string): Observable<User> {
        return this.getUserInfoFromJWT(idToken);
    }

    private getUserInfoFromJWT(idToken: string): Observable<User> {
        const userInfo = jwt_decode(idToken);
        const user = new User(
            userInfo.firstName,
            userInfo.lastName,
            Object.keys(userInfo.cfa_perms.NHD_APP),
            userInfo["cfa-guid"]
        );

        return of(user);
    }

}